/* Stepper množství u hlavního CTA na produktovém detailu (vzor produktová
   karta / product-card-cart.js). Atribut [in-cart] přepíná CTA ↔ stepper,
   výchozí stav vykreslí server přes `cart | item_count_for_variant`.
   Dawn při změně varianty buy-buttons blok nepřerenderuje (mění jen hidden
   input a disabled stav submitu), proto se tu navíc poslouchá variantChange
   a stav se dopočítá z košíku. */

if (!customElements.get('product-buy-cart')) {
  customElements.define(
    'product-buy-cart',
    class ProductBuyCart extends HTMLElement {
      connectedCallback() {
        this.stepper = this.querySelector('.pdp-buy__stepper');
        if (!this.stepper) return;

        this.variantId = Number(this.dataset.variantId);
        this.qtyElement = this.querySelector('[data-stepper-qty]');
        this.querySelector('[data-stepper-minus]').addEventListener('click', () => this.change(-1));
        this.querySelector('[data-stepper-plus]').addEventListener('click', () => this.change(1));

        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event.source === 'product-buy-cart' && event.element === this) return;
          this.syncFromCart(event.cartData);
        });

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId !== this.dataset.sectionId) return;
          const variant = event.data.variant;
          this.variantId = variant ? Number(variant.id) : null;
          if (!this.variantId) {
            this.setQuantity(0);
            return;
          }
          this.syncFromCart();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
        if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
      }

      get quantity() {
        return parseInt(this.qtyElement.textContent, 10) || 0;
      }

      setQuantity(quantity) {
        this.qtyElement.textContent = quantity;
        this.toggleAttribute('in-cart', quantity > 0);
      }

      async syncFromCart(cartData) {
        if (!this.variantId) return;
        try {
          // Odpověď /cart/add.js (submit CTA) nenese celý košík — došteme si ho
          let items = cartData && cartData.items;
          if (!items) {
            const response = await fetch(`${routes.cart_url}.js`);
            items = (await response.json()).items;
          }
          const quantity = items
            .filter((item) => item.variant_id === this.variantId)
            .reduce((sum, item) => sum + item.quantity, 0);
          this.setQuantity(quantity);
        } catch {
          /* síťová chyba — ponecháme poslední známý stav */
        }
      }

      async change(delta) {
        if (!this.variantId) return;
        const newQuantity = Math.max(0, this.quantity + delta);
        this.stepper.setAttribute('aria-busy', 'true');
        try {
          const response = await fetch(routes.cart_update_url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates: { [this.variantId]: newQuantity }, sections: 'cart-icon-bubble' }),
          });
          const cart = await response.json();
          if (cart.status) throw new Error(cart.message);

          const bubble = document.getElementById('cart-icon-bubble');
          if (bubble && cart.sections && cart.sections['cart-icon-bubble']) {
            const parsed = new DOMParser().parseFromString(cart.sections['cart-icon-bubble'], 'text/html');
            bubble.innerHTML = parsed.querySelector('.shopify-section').innerHTML;
          }

          // Skutečné množství z odpovědi (sklad může požadavek snížit)
          this.syncFromCart(cart);
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-buy-cart',
            element: this,
            cartData: cart,
            variantId: this.variantId,
          });
        } catch (error) {
          console.error(error);
        } finally {
          this.stepper.removeAttribute('aria-busy');
        }
      }
    }
  );
}
